import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, FormField, Input } from '@vd/ui';
import { AuthLayout } from './AuthLayout';
import { api } from '../../lib/api';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.forgotPassword(email.trim().toLowerCase());
    } catch {
      // Backend returns 204 regardless to prevent account enumeration.
    } finally {
      setSubmitting(false);
      setSent(true);
    }
  };

  return (
    <AuthLayout
      title={sent ? 'Check your email' : 'Reset your password'}
      subtitle={sent ? undefined : 'We’ll email you a link to set a new password.'}
      footer={<Link to="/signin">Back to sign in</Link>}
    >
      {sent ? (
        <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>
          If an account exists for <strong style={{ color: 'var(--text)' }}>{email}</strong>, we’ve sent a reset link. It’ll expire in 30 minutes.
        </p>
      ) : (
        <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <FormField label="Email">
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
          </FormField>
          <Button variant="primary" size="lg" loading={submitting} type="submit">
            Send reset link
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
